module.exports = __webpack_public_path__ + "img/bgtop1.ccb9c260.jpg";